import api, { ApiResponse } from './api';

import {
  PlantApi,
  GetPlantApiListProps,
  GetPlantApiProps,
  ClaimPlantProps,
  ClaimPlantResult,
  LinkFroniusPlantProps,
  LinkSharedPlantProps,
  LinkPlantResult,
} from 'entities/PlantApi';

interface GetPlantApiListResponse {
  success: boolean;
  data: PlantApi[];
}

export const getPlantApiListService = (
  data: GetPlantApiListProps
): ApiResponse<GetPlantApiListResponse> =>
  api({
    method: 'GET',
    url: `monitoring-system-api/${data.monitoringSystemUserId}/plants`,
    useToken: true,
  });

interface GetPlantApiResponse {
  success: boolean;
  data: PlantApi;
}

export const getPlantApiService = (
  data: GetPlantApiProps
): ApiResponse<GetPlantApiResponse> =>
  api({
    method: 'GET',
    url: `monitoring-system-api/${data.monitoringSystemUserId}/plants/${data.identifier}`,
    useToken: true,
  });

interface ClaimPlantResponse {
  success: boolean;
  data: ClaimPlantResult;
}

// Valida o link e devolve a usina resolvida — não grava nada. A planta é
// persistida junto com a UC, pelo caminho normal do formulário. Pode voltar
// { status: 'pending' } quando a conta mestre ainda não enxerga a usina.
export const claimPlantService = (
  data: ClaimPlantProps
): ApiResponse<ClaimPlantResponse> =>
  api({
    method: 'POST',
    url: 'monitoring-system-api/claim-plant',
    data,
    useToken: true,
  });

interface LinkPlantResponse {
  success: boolean;
  data: LinkPlantResult;
}

// "Associar Novo Monitoramento" para Fronius: reivindica E persiste a planta na
// UC escolhida. Também pode voltar { status: 'pending' }.
export const linkFroniusPlantService = (
  data: LinkFroniusPlantProps
): ApiResponse<LinkPlantResponse> =>
  api({
    method: 'POST',
    url: 'monitoring-system-api/link-fronius-plant',
    data,
    useToken: true,
  });

// "Associar Novo Monitoramento" para as contas mestre compartilhadas
// (ex.: Sungrow): reivindica E persiste a planta na UC. Também pode voltar
// { status: 'pending' } quando a conta mestre ainda não enxerga a usina.
export const linkSharedPlantService = (
  data: LinkSharedPlantProps
): ApiResponse<LinkPlantResponse> =>
  api({
    method: 'POST',
    url: 'monitoring-system-api/link-shared-plant',
    data,
    useToken: true,
  });

// Assistente (P4, out/2026): liga uma usina da conexão PRÓPRIA (login do app,
// ex.: Growatt) ao imóvel que ela abastece.
export const linkOwnPlantService = (data: {
  monitoringSystemUserId: string;
  identifier: string;
  consumerUnitId: string;
}): ApiResponse<{
  success: boolean;
  data: { identifier: string; name: string };
}> =>
  api({
    method: 'POST',
    url: 'monitoring-system-api/link-plant',
    data,
    useToken: true,
  });
